﻿import './api'
import store from './store'
import routes from './routes'
import components from './components'
import module from './module'

export default {
    module,
    routes,
    store,
    components
}